(function () {
  if (window.__storyVideoControlsReady) return;
  window.__storyVideoControlsReady = true;

  function initRoot(root) {
    if (!root || root.dataset.storyVideoInitialized === 'true') return;

    var video = root.querySelector('[data-story-video]');
    var wrap = root.matches('[data-story-video-wrap]') ? root : root.querySelector('[data-story-video-wrap]');
    var btn = root.querySelector('[data-story-video-toggle]');
    if (!video || !wrap || !btn) return;

    root.dataset.storyVideoInitialized = 'true';

    var poster = root.getAttribute('data-story-video-poster');
    if (poster) {
      try {
        video.setAttribute('poster', poster);
      } catch (e) {}
    }

    function setState(playing) {
      wrap.classList.toggle('is-playing', !!playing);
      var S = (window.gwaStrings && window.gwaStrings.story_video_controls) || {};
      btn.setAttribute('aria-label', playing ? S.stop_video || 'Stop video' : S.play_video || 'Play video');
    }

    function stop() {
      try {
        video.pause();
      } catch (e) {}
      try {
        video.currentTime = 0;
      } catch (e) {}
      setState(false);
    }

    function play() {
      try {
        var promise = video.play();
        if (promise && typeof promise.then === 'function') {
          promise.then(function () {
            setState(true);
          }).catch(function () {
            setState(false);
          });
        } else {
          setState(true);
        }
      } catch (e) {
        setState(false);
      }
    }

    btn.addEventListener('click', function () {
      if (video.paused) play();
      else stop();
    });

    video.addEventListener('ended', stop);
    video.addEventListener('pause', function () {
      if (video.currentTime === 0 || video.ended) setState(false);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-story-video-root]').forEach(initRoot);
  }

  initAll();
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
